<template>
  <h2 class="gradation">Video</h2>
  <div v-for="(video, $index) in video_list" :key="$index" class="content-list mb-7">
    <h4>{{ video.head }}</h4>
    <p class="description">{{ video.body }}</p>
    <iframe class="youtube_ifreme" width="560" height="315" :src="video.url" title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe>
  </div>
  <InfiniteLoading  @infinite="infiniteVideoHandler">
    <template #complete>
      <div class="text-center mb-15">現在公開されているエピソードはここまでです。</div>
    </template>
  </InfiniteLoading>
</template>

<style scoped>
.content-list:not(:first-child){
  margin-top: 8px;
}
.youtube_ifreme{
  aspect-ratio: 16 / 9;
  width: 100%;
  height: auto;  
}
.description {
  /* 二行のみ表示する。オーバーした場合…を表示する。 */
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 3;
  overflow: hidden;
  margin-bottom: 20px;
}
</style>

<script>
import axios from 'axios';
import InfiniteLoading from "v3-infinite-loading";
import "v3-infinite-loading/lib/style.css";
const video_api = '/api/video/list';

export default {
  name: 'VideoList',
  components: {
    InfiniteLoading
  },
  data(){
    return {
      video_page: 0,
      video_list: [],
      condition: ''
    }
  },
  // コンポーネントマウントリスナ
  async mounted() {
  },

  methods: {
    async infiniteVideoHandler($state){

      this.condition = 'requesting';

      const res = await axios.get(video_api, {
        params: {
          pg: this.video_page
        }
      }).catch(()=>{
        this.condition = 'fail'
        return;
      });

      console.log(res.data);
      console.log(`length: ${res.data.length}`);

      if( res.data.length > 0 ){
        this.video_page++;
        this.video_list.push(...res.data);
        $state.loaded();
      }else{
        $state.complete();
      }

      this.condition = 'done'
      }

  }
}
</script>